import { useInfiniteQuery } from '@tanstack/react-query'
import { aiStudioService, SampleResponse } from '../../../service/aiStudio'

export interface UseInfiniteSampleByGarmentParams {
  garmentType: string
  limit?: number
  enabled?: boolean
}

export const useInfiniteSampleByGarment = ({
  garmentType,
  limit = 20,
  enabled = true,
}: UseInfiniteSampleByGarmentParams) => {
  return useInfiniteQuery({
    queryKey: ['ai-studio', 'samples', garmentType, limit],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await aiStudioService.getSampleByGarmentWithPagination({
        garmentType,
        page: pageParam as number,
        limit,
      })
      return response
    },
    getNextPageParam: (lastPage: SampleResponse, allPages) => {
      const currentPage = lastPage.page
      const totalPages = Math.ceil(lastPage.total / lastPage.limit)
      return currentPage < totalPages ? currentPage + 1 : undefined
    },
    initialPageParam: 1,
    enabled: !!garmentType && enabled,
    staleTime: 30000, // 30초간 stale하지 않은 것으로 처리
  })
}